import { Button } from '@/components/PageHeading';
import { StatusScreen } from '@/components/StatusScreen';

/**
 * The API could not be reached at all.
 *
 * The template calls this one "under maintenance", and the copy here deliberately does not: the
 * client cannot tell a deployment from a dropped connection, and telling someone their shop's
 * software is being serviced when their own wifi is off sends them to the wrong place. Both causes
 * are named, and the action is the same either way.
 *
 * This is a *startup* screen, not a global handler. It appears only when the session restore on
 * load fails because nothing answered — a single failed request mid-session is the calling screen's
 * problem to report, and hijacking the whole app for one would throw away unsaved work.
 *
 * Retrying is a full reload rather than a second refresh call, and that is not laziness. Refreshing
 * *rotates* the token; presenting one that a previous attempt already retired is indistinguishable
 * from a stolen token server-side, and the answer is to revoke the whole family. A reload restarts
 * the one-shot restore cleanly. See the ref guard in `App`.
 */
export function MaintenancePage() {
  return (
    <StatusScreen
      standalone
      icon="ph-duotone ph-wrench"
      tone="warning"
      title="AttireRent is not answering"
      message="The server could not be reached. It may be restarting after an update, or this device may be offline. Nothing has been lost — try again in a moment."
      actions={
        <Button
          variant="primary"
          icon="icon icon-rotate-cw"
          onClick={() => window.location.reload()}
        >
          Try again
        </Button>
      }
    />
  );
}
